import { Avatar } from '@george-labs.com/design-system';

import { DateFormat } from '@luna/date';

import type { Payments } from './Payments';

type BusinessOnlyConfigs = 'shouldSendAddressBookInfoToApi';

export const base: Omit<Payments, BusinessOnlyConfigs> = {
    requestHeaders: {},
    avatarColor: Avatar.COLOR.STONE,
    shouldLoadBanks: false,
    checkDomesticMatchString: /^[\w öäüÖÄÜß()&.,-/+<>?;!"={}:_%*#§|\\$^[\]'\u20AC@]+$/.toString(),
    bankCodeInvalidReplaceString: /[^0-9]/g.toString(),
    ignoreLeadingZerosInAccountNumber: false,
    ignoreTrailingZerosInAccountNumber: false,
    useTransferDateWhenSigningDoneFlag: true,
    disableTransferDateForFxIntrabankPaymentReceiver: false,
    disableTransferDateForFX: false,
    transferDateTimeFormat: DateFormat.UTC_ISO_DATE_FORMAT,
    sendTransferDateToBookingDate: false,
    isoTransferDateFormatEnabled: true,
    hasCollectiveBundle: false,
    truncateSenderName: true,
    maxDaysInFuture: 90,
    feeFlags: true,
    localAccountId: null,
    additionalCopyableAttributes: [],
    daysOfRepetition: -1,
    putCancelledByUserToDone: false,
    urgentBadgeInSigning: true,
    showTransactionType: false,
    showFeeSharing: false,
    collectiveSigning: {
        showExtendedLabels: false,
        isMissingSignatureSupported: true,
    },
    useCollectiveSigning: false,
    handleLocalErrors: {
        errorCode: '',
        translationPath: '',
    },
    checkTransferAllowedForRedo: false,
    balanceToCalculateRemainingAmount: 'disposable',
    balanceToCalculateInsufficientFund: 'disposable',
    useReceiverEndpoint: false,
    instantPayments: {
        showIcon: true,
        snackbarSuccessStates: ['CLOSED'],
        snackbarFailedStates: ['CANCELLED', 'FAILED'],
        snackbarOverallTimeout: 30000,
        snackbarRepeatDelay: 2000,
        avoidShowingInfoMessages: false,
        shouldShowPendingResult: false,
        shouldShowSigningLogo: false,
    },
    preferBbanDisplay: false,
    maxTaxPositions: 7,
    autoCreateContactAfterPaymentFormSubmit: true,
    shouldClearPaymentFormOnIdNotFoundError: false,
    addressFieldsStructure: 'basic',
    bankDetailsToggleSecondaryType: 'BANK_CODE',
    trustedContactsAvailable: false,
    isApprovalExecutionAfterDeathAvailable: false,
    isPrioritizedGroupAccountsSearchEnabled: false,
    redoReplyEngine: 'gapi',
    shouldUseInitiatingAccountForVerificationOfPayeeFetching: false,
    shouldPrefillSenderNameFromAccount: true,
};
